$('.slider').slick({
    autoplay: true,//自動的に動き出すか。初期値はfalse。
    autoplaySpeed: 2000, // 自動再生の速さを設定（例：2000ミリ秒 = 2秒）
    infinite: true,//スライドをループさせるかどうか。初期値はtrue。
    slidesToShow: 3,//スライドを画面に3枚見せる
    slidesToScroll: 1,//1回のスクロールで1枚の写真を移動して見せる
    // prevArrow: '<div class="slick-prev"></div>',//矢印部分PreviewのHTMLを変更
    // nextArrow: '<div class="slick-next"></div>',//矢印部分NextのHTMLを変更
    dots: true,//下部ドットナビゲーションの表示
    centerMode: true, // 中央に揃える
    // centerPadding: '5%',
    responsive: [
      {
        breakpoint: 1400,//モニターの横幅が769px以下の見せ方
        settings: {
          slidesToShow: 2,//スライドを画面に2枚見せる
          slidesToScroll: 1,//1回のスクロールで2枚の写真を移動して見せる
        }
      },
      {
        breakpoint: 769,//モニターの横幅が769px以下の見せ方
        settings: {
          slidesToShow: 1,//スライドを画面に2枚見せる
          slidesToScroll: 1,//1回のスクロールで2枚の写真を移動して見せる
        }
      },
      {
        breakpoint: 500,//モニターの横幅が426px以下の見せ方
        settings: {
          centerMode: false,
          slidesToShow: 1,//スライドを画面に1枚見せる
          slidesToScroll: 1,//1回のスクロールで1枚の写真を移動して見せる
        }
      }
    ]
  });
  
  
  $(function () {
    var windowWidth = $(window).width();
    var windowSm = 768;
    if (windowWidth <= windowSm) {
      $(".slider_product").on("init", function (event, slick) {
        $(this).append('<div class="slick-num"><span class="now-count"></span> | <span class="all-count"></span></div>');
        $(".now-count").text(slick.currentSlide + 1); // 現在のスライド番号(+1が無いと0からスタートしてしまう)
        $(".all-count").text(slick.slideCount); // スライドの総数
      })
      .on("click", ".slick-dots li", function(event) {
        event.stopPropagation(); // クリックイベントの伝播を停止
      })
        .slick({
          autoplay: false,//自動的に動き出すか。初期値はfalse。
          infinite: true,//スライドをループさせるかどうか。初期値はtrue。
          slidesToShow: 1,//スライドを画面に1枚見せる
          slidesToScroll: 1,//1回のスクロールで1枚の写真を移動して見せる
          arrows: true,
          waitForAnimate: false,
          prevArrow: '<div class="slick-prev"></div>',//矢印部分PreviewのHTMLを変更
          nextArrow: '<div class="slick-next"></div>',//矢印部分NextのHTMLを変更
          centerMode: true, // 中央に揃える
          dots: true, // ドットナビゲーションを表示する＃
          customPaging: function (slick, index) {
            // スライダーのインデックス番号に対応した画像のsrcを取得
            let targetImage = slick.$slides.eq(index).find('img').attr('src');
            // slick-dots > li　の中に上記で取得した画像を設定
            return '<img src=" ' + targetImage + ' "/>';
          },
        })
        .on("beforeChange", function (event, slick, currentSlide, nextSlide) {
          $(".now-count").text(nextSlide + 1); // 現在のスライド番号の次のスライドになったら番号を+1
        });
  
        // .slick-listの高さの1/2を計算
      var slickListHeight = $(".slick-list").height();
      var halfSlickListHeight = slickListHeight / 2;
  
      // .slick-prevと.slick-nextにtopプロパティを設定
      $(".slick-prev, .slick-next").css("top", halfSlickListHeight + "px");
  
      $(".slick-num").css("top", slickListHeight - ( slickListHeight / 10 ) + "px");
  
    } else {
      $(".slider_product").slick({
        autoplay: false,//自動的に動き出すか。初期値はfalse。
        infinite: true,//スライドをループさせるかどうか。初期値はtrue。
        slidesToShow: 1,//スライドを画面に1枚見せる
        slidesToScroll: 1,//1回のスクロールで1枚の写真を移動して見せる
        arrows: true,
        waitForAnimate: false,
        prevArrow: '<div class="slick-prev"></div>',//矢印部分PreviewのHTMLを変更
        nextArrow: '<div class="slick-next"></div>',//矢印部分NextのHTMLを変更
        centerMode: true, // 中央に揃える
        dots: true, // ドットナビゲーションを表示する
        customPaging: function (slick, index) {
          // スライダーのインデックス番号に対応した画像のsrcを取得
          let targetImage = slick.$slides.eq(index).find('img').attr('src');
          // slick-dots > li　の中に上記で取得した画像を設定
          return '<img src=" ' + targetImage + ' "/>';
        },
      })
      // .slick-listの高さの1/2を計算
      var slickListHeight = $(".slick-list").height();
      var halfSlickListHeight = slickListHeight / 2;
  
      // .slick-prevと.slick-nextにtopプロパティを設定
      $(".slick-prev, .slick-next").css("top", halfSlickListHeight + "px");
    }
  });
  